import { render, staticRenderFns } from "./VisitPointCreateTabAccount.vue?vue&type=template&id=030f2398&scoped=true&"
import script from "./VisitPointCreateTabAccount.vue?vue&type=script&lang=js&"
export * from "./VisitPointCreateTabAccount.vue?vue&type=script&lang=js&"
import style0 from "./VisitPointCreateTabAccount.vue?vue&type=style&index=0&id=030f2398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030f2398",
  null
  
)

export default component.exports